import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	title: {
		color: colors.gray[900],
		fontWeight: 700
	},
	codeBlock: {
		border: "1px solid",
		borderColor: themeColors.colors.system.gray[200],
		borderRadius: 8,
		overflow: "hidden"
	},
	codeHeaderLabel: {
		width: "auto",
		padding: "6px 12px",
		backgroundColor: themeColors.colors.system.gray[50],
		borderBottom: "1px solid",
		borderColor: themeColors.colors.system.gray[200],
		color: themeColors.colors.system.gray[600]
	},
	codeHeaderLabelText: {
		fontWeight: 600,
		letterSpacing: "0.04em"
	}
})

export default useStyles
